import React from 'react';

export default function ReportsIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g fill='currentColor'>
          <path d='M8,7 C8.55228475,7 9,7.44771525 9,8 L9,19.649 L16.0465737,13.4695847 L18.834,16.395 L22.2151123,12.9396515 L21.2498424,12.9396515 C20.8701466,12.9396515 20.5563514,12.6574976 20.506689,12.291422 L20.4998424,12.1896515 C20.4998424,11.8099557 20.7819963,11.4961605 21.1480718,11.4464981 L21.2498424,11.4396515 L24.75,11.4396515 L24.75,14.6602845 C24.75,15.0744981 24.4142136,15.4102845 24,15.4102845 C23.6203042,15.4102845 23.306509,15.1281306 23.2568466,14.7620551 L23.25,14.6602845 L23.2491123,14.0276515 L18.8198295,18.5548734 L15.953,15.545 L9.09162629,21.5638845 L9,21.631 L9,23 L24,23 C24.5522847,23 25,23.4477153 25,24 C25,24.5522847 24.5522847,25 24,25 L8,25 C7.44771525,25 7,24.5522847 7,24 L7,8 C7,7.44771525 7.44771525,7 8,7 Z' />
        </g>
      </g>
    </svg>
  );
}
